import { Event } from './types';

// Start with no events; everything is created by the user.
export const initialEvents: Event[] = [];
